import { render, staticRenderFns } from "./RegistrationPageRoot.vue?vue&type=template&id=d97ff686&"
import script from "./RegistrationPageRoot.vue?vue&type=script&lang=js&"
export * from "./RegistrationPageRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports